import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitPaymentStepFormGroup } from '../../../../../records/components/members/ip-view-member-record/components/ip-member-record-variable-benefit-configuration/form-groups/variable-benefit-payment-step-form-group';

@Component({
  selector: 'app-variable-benefit-lump-sum-payment-details',
  templateUrl: './variable-benefit-lump-sum-payment-details.component.html',
  styleUrls: ['./variable-benefit-lump-sum-payment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitLumpSumPaymentDetailsComponent {
  @Input() paymentForm!: VariableBenefitPaymentStepFormGroup;
}
